/** Bunsen Lab Function Execution Statuses */
export const LAB_FUNCTION_STATUS = {
  RUNNING: 'RUNNING',
  ENDED: 'ENDED',
  ERROR: 'ERROR',
};

/** How often a running lab execution should be polled to get the latest result */
export const LAB_FUNCTION_POLL_INTERVAL = 3000;
